<template>
  <div class="about-page">
    <div class="content">
      <h2>
        <a href="/">
          ArtJump — автоматический генератор ссылок по ГОСТ онлайн
        </a>
      </h2>
      <div class="info">
          Цель нашего проекта — экономия времени исследователей, аспирантов и студентов при формировании списка источников научной статьи, дипломоной работы или диссертации.
          Такие ресурсы, как E-Library.ru, содержат полную библиографическую информацию о статьи.
          Но увы, оформление этой информации в соответствии с требованиями ГОСТ может занять очень много времени.
          Наша система берет данные статьи из E-library, форматирует их в соовтетствии с шаблоном, отвечающим требованиям ГОСТ.
      </div>
      <div class="info">
          Современному исследователю часто приходится давать ссылки на материалы сети Интернет, не оформленные в виде научной статьи. Подобные ссылки оформляются в соответствии с ГОСТ весьма неочевидным способом. Для упрощения форматирования таких ссылок у нас предусмотрен пункт «Ссылка на электронный ресурс». С сожалению, не представляется возможным автоматически определить имя автора публикации. Поэтому, если вы знаете имя автора, укажите его, нажав кнопку «Дополнительно».
      </div>
      <div class="info">
        В будущем мы предполагаем развить данный проект в полноценный редактор научных статей, который помимо ссылок будет упрощать и оформления самих статей. Вы можете ознакомиться с пробной версией редактора на соответствующей <router-link :to="{name: 'editor'}">странице</router-link>.
      </div>
      <div class="info">
        Если вы заметили неточность, либо просто хотите поделиться мыслями и предложениями по развитию проекта, вы можете оставить отзыв на соответствующей <a href="http://art-jump.reformal.ru/proj/">странице</a>.
      </div>
    </div>
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import FooterBar from '@/components/FooterBar.vue'
export default {
  name: 'AboutPage',
  components: {
    FooterBar
  }
}
</script>

<style lang="sass">
.about-page
  text-align: left
  padding: 30px 40px
.content
  min-height: 70vh
.info
  margin-top: 20px
  font-size: 1.5em
</style>


// WEBPACK FOOTER //
// AboutPage.vue?2fbf191c